export function getRedirectUrl() {
  const env = process.env.NEXT_PUBLIC_ENV;

  switch (env) {
    case 'local':
      return 'http://localhost:3000/lobby';
    case 'development':
      return 'https://dev-manager.martinsads.com.br/lobby';
    case 'staging':
      return 'https://hml-manager.martinsads.com.br/lobby';
    case 'production':
      return 'https://manager.martinsads.com.br/lobby';
    default:
      return 'http://localhost:3000/lobby';
  }
}
